import { Button, Space } from 'antd';
import type { ColumnsType } from 'antd/lib/table';
import moment from 'moment';
import type { Dispatch, SetStateAction } from 'react';
import React from 'react';

import type { Instructor } from '@/types/database/instructor';

import DeleteInstructorButton from '../components/DeleteInstructorButton';
import EditInstructorButton from '../components/EditInstructorButton';

export const getColumns = (
  updateTableData: () => void,
  setSelectedInstructor: Dispatch<SetStateAction<Instructor | null>>
) => {
  const columns: ColumnsType<Instructor> = [
    {
      dataIndex: 'createdTime',
      key: 'createdTime',
      title: '建立時間',
      render: (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      dataIndex: 'name',
      key: 'name',
      title: '講師姓名',
    },
    {
      dataIndex: 'phone',
      key: 'phone',
      title: '手機號碼',
    },
    {
      dataIndex: 'title',
      key: 'title',
      title: '頭銜',
    },
    {
      dataIndex: 'updatedTime',
      key: 'updatedTime',
      title: '更新時間',
      render: (value) => moment(value).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      dataIndex: '_id',
      key: '_id',
      title: '操作',
      render: (value, record) => {
        return (
          <Space>
            <Button
              onClick={() =>
                setSelectedInstructor((prev) => {
                  if (prev?._id === record._id) {
                    return null;
                  }
                  return record;
                })
              }
            >
              查看
            </Button>
            <EditInstructorButton
              buttonLabel="編輯"
              instructor={record}
              onConfirm={updateTableData}
            />
            <DeleteInstructorButton updateData={updateTableData} id={value} />
          </Space>
        );
      },
    },
  ];
  return columns;
};
